import { RegReqLabel } from "../../ui/RegReqLabel";

/** Shared Yes/No radio pair for registration profile steps. */
export function YesNoRadios({
  name,
  label,
  required,
  value,
  error,
  onChange,
  onBlur,
}: {
  name: string;
  label: string;
  required?: boolean;
  value: boolean | null;
  error?: string;
  onChange: (next: boolean) => void;
  onBlur: () => void;
}) {
  return (
    <fieldset className="reg-field reg-field--full">
      <legend>
        {required ? <RegReqLabel required>{label}</RegReqLabel> : <span>{label}</span>}
      </legend>
      <div className="reg-inline-radios">
        <label className="reg-radio-label">
          <input
            type="radio"
            name={name}
            checked={value === true}
            onChange={() => onChange(true)}
            onBlur={onBlur}
          />
          <span>Yes</span>
        </label>
        <label className="reg-radio-label">
          <input
            type="radio"
            name={name}
            checked={value === false}
            onChange={() => onChange(false)}
            onBlur={onBlur}
          />
          <span>No</span>
        </label>
      </div>
      {error ? <small className="reg-field-error">{error}</small> : null}
    </fieldset>
  );
}
